<form [formGroup]="planSettingsService.drawSettingsForm">
  <!--DRAWING SETTINGS-->
  <div *ngIf="this.planSettings && measurementUnit" class="flex flex-col gap-sm">
    <efp-list-header>
      <ion-label>{{ 'SETTINGS.DRAWING_SETTINGS' | translate }}</ion-label>
    </efp-list-header>

    <doka-select
      [label]="'SETTINGS.MEASUREMENT' | translate"
      formControlName="measurementUnit"
      data-test-selector="drawingsettings-open-unit-selection">
      <ng-container *ngFor="let item of unitsOfLength; index as i">
        <doka-select-option
          [value]="item"
          *ngIf="i !== unitsOfLength.length - 1"
          [label]="item"></doka-select-option>
      </ng-container>
      <doka-select-option
        value="inch"
        [label]="'GENERAL.INCH' | translate"
        data-test-selector="drawingsettings-unit-selection-inch"></doka-select-option>
    </doka-select>

    <doka-number-input
      *ngIf="isDrawingMode"
      formControlName="angleRastering"
      efpInputOverwritingSelect
      [label]="'SETTINGS.ANGLE_RASTERING' | translate"
      [alert]="
        angleRastering.invalid
          ? ('SETTINGS.ANGLE_ERROR'
            | translate
              : {
                  minAngle: angleRasteringInterval[0],
                  maxAngle: angleRasteringInterval[1]
                })
          : ''
      "
      [unit]="'°'"
      [step]="1"
      [showStep]="true">
    </doka-number-input>

    <efp-length-input-editor
      *ngIf="isDrawingMode || isCycleMode"
      efpInputOverwritingSelect
      [unit]="measurementUnit.value"
      [label]="'SETTINGS.LENGTH_RASTERING' | translate"
      [showUnit]="true"
      [step]="1"
      formControlName="lengthRastering"
      [alert]="
        lengthRastering.invalid
          ? ('SETTINGS.LENGTH_ERROR'
            | translate
              : {
                  minLength: lengthRasteringInterval[0] | efpLength : measurementUnit.value,
                  maxLength: lengthRasteringInterval[1] | efpLength : measurementUnit.value
                })
          : ''
      ">
    </efp-length-input-editor>

    <!--Plan settings - Wall-->
    <ng-container
      *ngIf="(isPlanMode || isDrawingMode) && (buildingType === 'WALL' || !buildingType)">
      <!-- Wall Thickness -->
      <efp-length-input-editor
        #wallThicknessInput
        [unit]="measurementUnit.value"
        [label]="'SETTINGS.WALL_THICKNESS' | translate"
        [showUnit]="true"
        formControlName="wallThickness"
        [alert]="
          wallThickness.invalid
            ? ('SETTINGS.WALL_THICKNESS_ERROR'
              | translate
                : {
                    minThickness: wallThicknessInterval[0] | efpLength : measurementUnit.value,
                    maxThickness: wallThicknessInterval[1] | efpLength : measurementUnit.value
                  })
            : ''
        ">
      </efp-length-input-editor>

      <!-- Wall Height -->
      <efp-length-input-editor
        #wallThicknessInput
        [unit]="measurementUnit.value"
        [label]="'SETTINGS.WALL_HEIGHT' | translate"
        [showUnit]="true"
        formControlName="wallHeight"
        [desc]="'PLAN.MEASURE.WARNING_HEIGHT_CHANGE' | translate"
        [alert]="
          wallHeight.invalid
            ? ('SETTINGS.WALL_HEIGHT_ERROR'
              | translate
                : {
                    minHeight: wallHeightInterval[0] | efpLength : measurementUnit.value,
                    maxHeight: wallHeightInterval[1] | efpLength : measurementUnit.value
                  })
            : ''
        "
        data-test-selector="drawingsettings-input-wall-height">
      </efp-length-input-editor>
    </ng-container>

    <!-- Slab thickness -->
    <ng-container *ngIf="buildingType === 'SLAB' || !buildingType">
      <efp-length-input-editor
        [unit]="measurementUnit.value"
        [label]="'SETTINGS.SLAB_THICKNESS' | translate"
        [showUnit]="true"
        formControlName="slabThickness"
        [alert]="
          slabThickness.invalid
            ? ('SETTINGS.SLAB_THICKNESS_ERROR'
              | translate
                : {
                    minThickness: slabThicknessInterval[0] | efpLength : measurementUnit.value,
                    maxThickness: slabThicknessInterval[1] | efpLength : measurementUnit.value
                  })
            : ''
        "
        data-test-selector="drawingsettings-input-slab-thickness">
      </efp-length-input-editor>

      <!-- Top slab level -->
      <efp-length-input-editor
        [unit]="measurementUnit.value"
        [label]="'SETTINGS.SLAB_HEIGHT' | translate"
        [showUnit]="true"
        formControlName="slabHeight"
        [desc]="'PLAN.MEASURE.WARNING_HEIGHT_CHANGE' | translate"
        [alert]="
          slabHeight.invalid
            ? ('SETTINGS.SLAB_HEIGHT_ERROR'
              | translate
                : {
                    minHeight: slabHeightInterval[0] | efpLength : measurementUnit.value,
                    maxHeight: slabHeightInterval[1] | efpLength : measurementUnit.value
                  })
            : ''
        "
        data-test-selector="drawingsettings-input-slab-height">
      </efp-length-input-editor>
    </ng-container>
  </div>
</form>
